<div class="newsletter-wrapper">
  <div class="newsletter-container">
    <h1 class="newsletter-title">Newsletter</h1>

    <!-- ✅ Usamos async pipe para desbloquear OnPush -->
    @if (posts$ | async; as posts) {

    @if (posts.length > 0 && !error) {
    <div class="newsletter-carousel" (mouseenter)="onPointerEnter()" (mouseleave)="onPointerLeave()"
      (touchstart)="onPointerEnter()" (touchend)="onPointerLeave()">
      <!-- Scroll Container -->
      <div class="newsletter-scroll-container" #scrollContainer>
        @for (post of posts; track post.id) {
        <div class="newsletter-card">
          <div class="newsletter-card-image">
            <!-- ✅ loading="lazy" evita que las imágenes bloqueen el renderizado inicial -->
            <img [src]="post.imageUrl" [alt]="post.name" loading="lazy" />
          </div>

          <div class="newsletter-card-content">
            <h2 class="newsletter-card-title">{{ post.name }}</h2>
            <p class="newsletter-card-description">{{ post.description }}</p>

            <a [href]="post.link" target="_blank" rel="noopener noreferrer" class="newsletter-read-more">
              Leer en Substack
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3">
                </path>
              </svg>
            </a>
          </div>
        </div>
        }
      </div>

      <!-- Navigation Buttons -->
      <div class="newsletter-nav-buttons">
        <button (click)="scroll('left')" class="newsletter-nav-button" aria-label="Anterior">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        <button (click)="scroll('right')" class="newsletter-nav-button" aria-label="Siguiente">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>
    }

    @if (error) {
    <div class="newsletter-error">
      <p class="newsletter-error-text">No se pudieron cargar las noticias.</p>
      <button (click)="retryLoadPosts()" class="newsletter-retry-button">
        Reintentar
      </button>
    </div>
    }
    }

    <!-- Spinner de carga (se muestra mientras el async pipe aún no emite) -->
    @if (loading) {
    <div class="newsletter-loading">
      <div class="newsletter-spinner"></div>
    </div>
    }
  </div>
</div>